import { CRMAPIBase } from '@api/crmApiBase';
import { CallSettingsResp } from '@api/responseModels/callSettings/callSettingsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class CallSettingsGroup extends CRMAPIBase {
    async getCallSettings({
        crm_id,
    }: {
        crm_id: number;
    }): Promise<RequestResult<CallSettingsResp>> {
        const result = await this.get<CallSettingsResp>('/call-settings/by-crm', { crm_id });
        return result;
    }

    async updateCallSettings({
        id,
        crm_id,
        viewer_ids,
        responsibles,
    }: {
        id: number;
        crm_id: number;
        viewer_ids: number[];
        responsibles: {
            id: number;
            sessions: { id: number; can_receive_calls: boolean; can_see_modal: boolean }[];
        }[];
    }): Promise<RequestResult<CallSettingsResp>> {
        const result = await this.put<null>(`/call-settings/${id}`, {
            crm_id,
            viewer_ids,
            responsibles,
        });
        return result;
    }
}

export { CallSettingsGroup };
